import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { Grid, Stack } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { JobFormTitle } from "@/features/job/components/job-form/JobFormTitle";
import { TJobForm } from "@/features/job/types/JobForm";
import { Textarea } from "@/components/elements/Textarea";

type TJobBenefitProps = {
  isDraft?: boolean;
};

export const JobBenefit: FC<TJobBenefitProps> = ({ isDraft }) => {
  const methods = useFormContext<TJobForm>();
  const { control } = methods;

  return (
    <Stack gap={2}>
      <InnerBox title={<JobFormTitle text="福利厚生" /> } showDivider={false}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormField control={control} name="companyAccommodation">
              <Textarea />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="specifiedSkillNo2">
              <Textarea />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="otherBenefits">
              <Textarea />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="insuranceStatus">
              <Input placeholder="入力してください" />
            </FormField>
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
